import { ReactNode } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { TCharacteristicsProps } from '@r1-frontend/ui-react/components/List/Characteristics/Characteristics';
import { IndentContainer, RounderContainer, withRadius } from '@r1-frontend/ui-react/experimental/containers';

import DesktopRouterCard from './Desktop';

import { ImageWrapper, LabelWrapper } from './styled';

export type TStaticDesktopRouter = {
    image: string,
    title: string | JSX.Element,
    description: string | JSX.Element,
    characteristics: TCharacteristicsProps[] | string,
    price: number,
    period: number,
    entityUriPath: string,
    onButtonClick: () => void,
    onCostClick?: () => void,

    isTestDrive?: boolean,
    isCredit?: boolean,
    labels?: ReactNode[],
    previousPrice?: number,
    className?: string,
    buttonName?: string,
}

const StaticDesktopRouter  = ({ labels, ...props }: TStaticDesktopRouter): JSX.Element => {
    return (
        <div className={props.className} data-test={'RouterCard'}>
            <IndentContainer $united={[8]}>
                <RounderContainer $desktop={24} $mobile={16}>
                    <ImageWrapper>
                        <LabelWrapper>{labels}</LabelWrapper>
                        <LazyLoadImage src={props.image} key={props.image} alt={'equipment'} height={112}/>
                    </ImageWrapper>
                </RounderContainer>
            </IndentContainer>
            <IndentContainer $mobile={[4, 12, 12]} $desktop={[8, 24, 24]}>
                <DesktopRouterCard {...props} characteristics={props.characteristics} data-test={'RouterCard-desktop'}/>
            </IndentContainer>
        </div>
    );
};

export default withRadius<TStaticDesktopRouter>(StaticDesktopRouter, { $desktop: 32, $mobile: 24 });
